// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.draggableTable_hd__typo__0xRcc {
  font-size: 0.7rem !important;
  color: #c2c2c2 !important;
  border-bottom: none !important;
  padding: 0 !important;
}

.draggableTable_brd_bottom__rmv__sEPln {
  border-bottom: none !important;
  padding: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/DraggableTasks/css/draggableTable.module.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,UAAU;AACZ","sourcesContent":[".hd__typo {\n  font-size: 0.7rem !important;\n  color: #c2c2c2 !important;\n  border-bottom: none !important;\n  padding: 0 !important;\n}\n\n.brd_bottom__rmv {\n  border-bottom: none !important;\n  padding: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hd__typo": `draggableTable_hd__typo__0xRcc`,
	"brd_bottom__rmv": `draggableTable_brd_bottom__rmv__sEPln`
};
export default ___CSS_LOADER_EXPORT___;
